import React from 'react';

import MessageRich from 'components/message-rich';

const MessagePreview = ({ controlsDisabled, ...message }) => (
    <MessageRich
        id={message.id}
        type={message.type}
        text={message.text}
        url={message.url}
        docAttachment={message.doc_attachment}
        attachments={message.attachments}
        system={Boolean(message.subtype)}
        systemMessageType={message.subtype}
        systemMessageData={message.system_message_data || message.system_comment_data}
        author={message.author}
        createdAt={message.created_at}
        audioDuration={message.audio_duration}
        heardBy={message.heardBy}
        fragment={message.fragment}
        controlsDisabled={controlsDisabled}
        clicksEnabled={false}
    />
)

export default MessagePreview;
